// extracted by mini-css-extract-plugin
export default {"pagination":"SuperPagination_pagination__JGXHk","text1":"SuperPagination_text1__mb0AA","text2":"SuperPagination_text2__3pzdB","select":"SuperPagination_select__+Dzn5"};